/* global sessionStorage */
import axios from 'axios';
import axiosConfig from '../config/axios.config'

export const trackActivity = (activity) => {
  const body = {
    user: activity.body && activity.body.user ? activity.body.user : false,
    log: {
        _id: activity.body._id,
        timestamp: Date.now()
    },
    instance: activity.body.instance
  }
  axios.post(`${axiosConfig.localUrl}/backend/post-activity`, body).then().catch(err => console.log(err))
}


export const trackError = (error, history) => {
  const body = {
    error: error,
    history: history,
    timestamp: Date.now()
  }

  axios.post(`${axiosConfig.localUrl}/backend/post-error`, body).then().catch(err => console.log(err))
}

